module.exports = __webpack_public_path__ + "static/testimonials-bg-5e3b34fd71bddc6adf0cf08193cd4547.svg";